// extracted by mini-css-extract-plugin
export default {"myModal":"MyModal_myModal__iJ2xb","myModalContent":"MyModal_myModalContent__Pid0y","active":"MyModal_active__BxgqI"};